<template>
    <div class="ae-list-w">
        <div class="ae-list">
            <div class="ae-item" v-for="product in products" :class="checkActiveClass(product)" @click="onSelectedProduct(product)">
                <div class="aei-image" v-if="product.preview && product.preview != null">
                    <div class="user-avatar-w"><img alt="" :src="product.preview" loading="lazy"></div>
                </div>
                <div class="aei-content">
                    <div class="aei-timestamp">
                        <img class="user-avatar" :src="product.lock_avatar" v-if="product.lock_avatar">
                    </div>
                    <h6 class="aei-title">{{productDisplayName(product)}}</h6>
                    <div class="aei-sub-title">{{product.item_identifier || '--'}}</div>
                    <div class="aei-sub-title">{{product.brand}} - {{product.category_name || '--'}}</div>
                    <div class="aei-sub-title">{{product.gender || '--'}}</div>
                    <!-- <div class="aei-sub-title">Contributors: {{product.photographers || '--'}}</div>
                    <div class="aei-sub-title">Last Session: {{product.id_photodesk_session || product.id_pretouchdesk_session}}</div> -->
                    <div class="aei-sub-title" v-if="product.reporting_class">{{product.reporting_class || '--'}}</div>
                    <div class="aei-text" v-if="product.type">{{product.type}} Shoot</div>
                    <div class="aei-text" v-if="product.date_received">Received {{product.date_received}}</div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Product from '@/mixins/product'
export default {
  props: ['products', 'parent', 'selectedProduct', 'lockedProducts'],
  mixins: [Product],
  methods: {
    onSelectedProduct: function (product) {
      this.$emit('productRailInterface', product)
    },
    checkActiveClass: function (product) {
      if (this.selectedProduct != null) {
        return (product.id_product == this.selectedProduct.id_product && product.id_channel == this.selectedProduct.id_channel ? 'active' : '')
      }
    },

  },

}
</script>

<style scoped>
    h6, .h6 {
        font-size: 1rem !important;
    }
    .aei-content {
        width: 100%;
    }
    .aei-timestamp {
        color: #047bf8 !important;
        font-size: 15px !important;
    }
    .ae-list-w {
        border-right: none !important;
    }
    .ae-list-w .ae-list .aei-image .user-avatar-w img {
        border-radius: 0px;
    }
    .ae-list-w .ae-list .ae-item.active .user-avatar-w {
        border-radius: 0px;
    }
    .user-avatar {
        border-radius: 50%;
        width: 32px;
        height: 32px;
    }
</style>
